import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "border mb-5 px-3 py-2 mx-6 flex dark:border-yellow-900 dark:bg-yellow-800 border-yellow-300 bg-yellow-100",
  style: {"user-select":"contain","border-radius":"0.5rem"}
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-xl my-auto pr-2 text-yellow-400 dark:text-yellow-500" }, "warning", -1)
const _hoisted_4 = { class: "w-full my-auto text-gray-800 dark:text-dark-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}